import enableGoogleMaps from './../class/EnableGoogleMaps';

jQuery(function(){

  var $enableMapWrapper = $('.google-map-auto-wrapper');
  // var $enableMap = $('.enable-map');

  if($enableMapWrapper.length > 0){

    setTimeout(function(){
      new enableGoogleMaps();
    }, 1000);

  }


});



// WEBPACK FOOTER //
// ./scripts/autoload/_map.js